import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import { t } from '@if/core/i18n'
import { closeSnackbar, SnackbarProvider, useSnackbar } from 'notistack'
import { useMemo, type ReactNode } from 'react'

export const useNotification = () => {
  const { enqueueSnackbar } = useSnackbar()
  return useMemo(
    () => ({
      showSuccess: (message?: string) =>
        enqueueSnackbar(message ?? t('common.messages.success'), { variant: 'success' }),
      showError: (message?: string) => enqueueSnackbar(message ?? t('common.messages.error'), { variant: 'error' }),
    }),
    [enqueueSnackbar],
  )
}

interface Props {
  children: ReactNode
}

const NotificationProvider = ({ children }: Props) => {
  return (
    <SnackbarProvider
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      dense
      action={(snackbarId) => (
        <IconButton size="small" color="inherit" onClick={() => closeSnackbar(snackbarId)}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  )
}

export default NotificationProvider
